import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import isNil from 'lodash/isNil';
import values from 'lodash/values';
import { NOTIFICATION_STATUS } from 'modules/community/constants';

export const VISIBLE_COMMENT_STATUS = (t) => ({
  [NOTIFICATION_STATUS.nonRevised]: t('community.not_reviewed'),
  [NOTIFICATION_STATUS.approved]: t('community.aproved'),
  [NOTIFICATION_STATUS.reproved]: t('community.reproved'),
  [NOTIFICATION_STATUS.markedAsSpamByOwner]: t('community.marked_as_spam'),
  [NOTIFICATION_STATUS.all]: t('general.all')
});

export const HIDDEN_COMMENT_STATUS = (t) => ({
  [NOTIFICATION_STATUS.markedAsSpamByUser]: t('community.marked_as_spam'),
  [NOTIFICATION_STATUS.editing]: t('general.edit')
});

export const TABS = (t) => {
  const labels = VISIBLE_COMMENT_STATUS(t);

  return [
    { name: labels[NOTIFICATION_STATUS.nonRevised], track: 'Not Reviewed' },
    { name: labels[NOTIFICATION_STATUS.approved], track: 'Approved' },
    { name: labels[NOTIFICATION_STATUS.reproved], track: 'Rejected' },
    {
      name: labels[NOTIFICATION_STATUS.markedAsSpamByOwner],
      track: 'Marked as Spam'
    },
    { name: labels[NOTIFICATION_STATUS.all], track: 'All' },
    { name: t('config_manager.title'), track: 'Settings' }
  ];
};

export const COMMENT_STATUS = (t) => ({
  ...VISIBLE_COMMENT_STATUS(t),
  ...HIDDEN_COMMENT_STATUS(t)
});

export const COMMENT_STATUS_AS_OBJECT = (t) => {
  const STATUS_BY_NAME = COMMENT_STATUS(t);

  return Object.keys(STATUS_BY_NAME).reduce(
    (map, status) => ({
      ...map,
      [status]: {
        value: status,
        label: STATUS_BY_NAME[status]
      }
    }),
    {}
  );
};

export function partitionOrphanPagesFromModules(list) {
  const modules = {};
  const orphanPages = {};

  (list || []).forEach((item) => {
    if (isNil(item.moduleId)) {
      // pages from this module are no longer orphan
      delete orphanPages[item.id];

      modules[item.id] = item.id;
    } else if (!(item.moduleId in modules)) {
      orphanPages[item.moduleId] = orphanPages[item.moduleId] || [];

      // this page is orphan, until proven otherwise
      orphanPages[item.moduleId].push(item.id);
    }
  });

  return { modules: values(modules), pages: flatten(values(orphanPages)) };
}

export function getSummaryOfSelectedPagesAndModules(t, list) {
  const buildCounterString = (counter, label) => {
    return counter > 0
      ? `${counter} ${t(label, { amountToPluralize: counter })}`
      : '';
  };

  const buildSelectedString = (amountOfModules, amountOfPages) => {
    if (amountOfModules === 0) {
      // only page(s)
      return t('general.selected_f', { amountToPluralize: amountOfPages });
    }

    return t('general.selected_m', {
      amountToPluralize: amountOfModules + amountOfPages
    });
  };

  const { modules, pages } = partitionOrphanPagesFromModules(list);

  const amountOfPages = pages.length;
  const amountOfModules = modules.length;

  const counterStrings = [
    buildCounterString(amountOfModules, 'general.module'),
    buildCounterString(amountOfPages, 'general.page')
  ];

  const nonEmptyCounterStrings = compact(counterStrings);
  const genderedSelectedString = buildSelectedString(
    amountOfModules,
    amountOfPages
  );

  return `${nonEmptyCounterStrings.join(
    ` ${t('general.and')} `
  )} ${genderedSelectedString}`.toLocaleLowerCase();
}
